<template>
    <div
        @dragover.prevent
        @click="pickFile"
        @drop="onDrop"
    >
        <v-layout
            row
            wrap
            align-center
            justify-center
            class="file-input"
        >
            <v-flex
                xs6 md4 lg4
                 class="file-input__label"
            >
                <v-progress-circular
                    :color="loadColor"
                    :width="3"
                    size="25"
                    indeterminate
                    v-if="loading"
                ></v-progress-circular>
                <span v-else>
                    <i :class="`bexsicon-${appendIcon}`" />
                    {{ label }}
                </span>
            </v-flex>
            <v-flex xs3 md3 lg3 v-if="!mobile">
                <v-btn
                    :class="`
                        file-input__drag-drop
                        ${dragAndDropClass}`"
                    :disabled="disabled || loading"
                >
                    {{ dragAndDropLabel }}
                </v-btn>
            </v-flex>
            <v-flex
                xs1
                class="file-input__divider"
                v-if="!mobile"
            >
                {{ $t('labels.or') }}
            </v-flex>
            <v-spacer v-else/>
            <v-flex xs5 md3 lg3>
                <v-btn
                    :class="`file-input__btn ${btnClass}`"
                    :disabled="disabled || loading"
                >
                    {{ btnLabel }}
                </v-btn>
            </v-flex>
        </v-layout>
        <input
            type="file"
            style="display: none"
            ref="fileInput"
            accept="*"
            @change="onFilePicked"
            multiple
        />
    </div>
</template>
<script>
export default {
  name: 'file-input',
  props: {
    btnLabel: {
      type: String,
      required: true
    },
    dragAndDropLabel: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    btnClass: {
      type: String,
      required: true
    },
    loadColor: {
      type: String,
      required: true
    },
    dragAndDropClass: {
      type: String,
      required: true
    },
    appendIcon: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxFileSize: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    loading: false,
    error: false
  }),
  methods: {
    pickFile() {
      this.$refs.fileInput.click();
    },
    onDrop(e) {
      e.stopPropagation();
      e.preventDefault();

      this.onFilePicked(e.dataTransfer.files, false);
    },
    async onFilePicked(e, fromClick = true) {
      try {
        if (this.disabled || this.loading) return;

        this.loading = true;
        this.error = false;

        const files = fromClick ? e.target.files : e;
        if (files.length === 0) return;

        const fileReadings = [];
        for (const file of files) {
          if (file === undefined) continue;

          if (file.name.lastIndexOf('.') <= 0 || !file.type) {
            this.$emit('fileInvalid', file.name);
            return;
          }

          if (this.maxFileSize) {
            file.sizeInMb = file.size / 1024 / 1024;

            if (file.sizeInMb > this.maxFileSize) {
              this.$emit('fileToLarge', file.sizeInMb);
              return;
            }
          }

          fileReadings.push(this.readFile(file));
        }

        const result = await Promise.all(fileReadings);
        this.$emit('input', result);
      } catch (err) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    readFile(file) {
      return new Promise((resolve, reject) => {
        const fr = new FileReader();

        fr.addEventListener('load', () => {
          const result = {
            title: file.name,
            file: fr.result,
            binary: file
          };
          resolve(result);
        });

        fr.addEventListener('error', err => {
          reject(err);
        });

        fr.readAsDataURL(file);
      });
    }
  }
};
</script>
<style lang="scss">
@import '../../assets/scss/breakpoint';

.file-input {
  width: 100%;
  font-size: 0.9em;

  .v-btn {
    font-size: 1em;
    width: 100%;
    padding: 0 !important;
    margin: 0;
    @include breakpoint(mobile) {
      font-size: 0.9em;
      padding: 0 1em !important;
    }
  }

  .v-btn__content {
    display: inline;
  }

  &__label {
    text-align: right;
    padding-right: 15px;
  }

  &__divider {
    text-align: center;
  }

  &__drag-drop {
    border: 1px dashed !important;
  }

  &__btn {
    @include breakpoint(mobile) {
      margin-left: -24px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fields/FileInput.vue